import { createSelector } from 'reselect';

export const modalSelector = state => state.reduxModal;

export const isModalOpenedSelector = createSelector(
  modalSelector,
  modal => !!modal.name,
);
